import { Cloudinary, Transformation } from 'cloudinary-core';
import isEmpty from 'lodash/isEmpty';

export const cloudinaryCore = new Cloudinary({ cloud_name: process.env.REACT_APP_CLOUDINARY_APP });

export const getVersion = (url: string) => {
	const matches = url.match(/upload\/v(\d+)\//);
	return matches ? matches[1] : null;
};

export const getImageUrl = (publicId: string, options: Transformation.Options = {}) => {
	const { format, ...rest } = options;
	return cloudinaryCore.url(`${publicId}.${format || 'jpg'}`, { ...rest });
};

export const getVideoUrl = (publicId: string, options?: Transformation.VideoOptions) => {
	return cloudinaryCore.video_url(publicId, options);
};

export const getVideoPreviewUrl = (publicId: string, options?: Transformation | Transformation.VideoOptions) => {
	return cloudinaryCore.video_thumbnail_url(publicId, { format: 'jpg', ...options });
};

export const isFolderNameValid = (name: string) => isEmpty(name.match(/[?&#\\%<>+/]/gi)) && name.toLowerCase() !== 'samples';
